export function getLastWorkingDayOfMonth(startDate = new Date())
{
    var month = startDate.getMonth();
    var year = startDate.getFullYear();
    var t = new Date(year, month + 1, 0);
    while (t.getDay() == 0 || t.getDay() == 6) {
        t.setDate(t.getDate() - 1);
    }
    if (t <= startDate) {
        return getLastWorkingDayOfMonth(new Date(year, month + 1, 1));
    } else {
        return t;
    }
}

export function getLastDayNumberOfMonth(dayOfWeek, today = new Date()) {
    // Sunday 0, Monday 1 etc
    var month = today.getMonth();
    var year = today.getFullYear();
    var t = new Date(year, month + 1, 0);
    while (t.getDay() != dayOfWeek) {
        t.setDate(t.getDate() - 1);
    }
    if (t <= today) {
        return getLastDayNumberOfMonth(dayOfWeek, new Date(year, month + 1, 1));
    } else {
        return t;
    }
}

export function getPayDatesForPayFrequency(payfrequency) {
    var today = new Date();
    var nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    switch (payfrequency) {
        case 'last_monday':
        case 'last_tuesday':
        case 'last_wednesday':
        case 'last_thursday':
        case 'last_friday':
            let numberMap = {
                'last_monday': 1,
                'last_tuesday': 2,
                'last_wednesday': 3,
                'last_thursday': 4,
                'last_friday': 5,
            };
            let nextPayDate = getLastDayNumberOfMonth(numberMap[payfrequency]);
            let followingPayDate = getLastDayNumberOfMonth(numberMap[payfrequency], new Date(nextPayDate.getFullYear(), nextPayDate.getMonth() + 1, 1));
            return [
                getNormalizedISOString(nextPayDate),
                getNormalizedISOString(followingPayDate)
            ];
        case 'last_working_day':
            nextPayDate = getLastWorkingDayOfMonth();
            followingPayDate = getLastWorkingDayOfMonth(new Date(nextPayDate.getFullYear(), nextPayDate.getMonth() + 1, 1));
            
            return [
                getNormalizedISOString(nextPayDate),
                getNormalizedISOString(followingPayDate)
            ];
        default:
            return null;
            break;
    }   
}

export function setPayDate(fieldName, date) {
    // get all of the options and loop backwards
    let element = $('[name=' + fieldName + ']');
    let options = element.find('option');
    let optionsArray = {};
    options.each((i, e) => {
        let $e = $(e);
        optionsArray[$e.attr('value')] = e.hasAttribute('disabled');
    });
    // Get index
    let index = Object.keys(optionsArray).indexOf(date);
    optionsArray = Object.entries(optionsArray);
    var dateToSet = null;
    for (index; index > 0; index--) {
        if (optionsArray[index][1] == true) {
            continue;
        } else{
            dateToSet = optionsArray[index][0];
            break;
        }
    }
    if (dateToSet != null) {
        element.val(dateToSet).change();
    } else {
        // Show the field probs
    }
}

export function getNormalizedISOString(date)
{
    return new Date(date.setHours(12)).toISOString().split('T')[0];
}